import { Alert } from '@startuptools/ui/Alert';
import { NumberFormat } from '@startuptools/ui/NumberFormat';
import { Table } from '@startuptools/ui/Table';
import { Trans, useLingui } from '@lingui/react';
import { useOsrVestedAndAllocatedSuspenseQuery } from './options-subscribers.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Identity } from '@startuptools/business-ui/identity/Identity';
import { type Dispatch, type SetStateAction } from 'react';

export const SelectOptionsSubscriberDialog = ({
  osrId,
  setSelected,
}: {
  osrId: string;
  setSelected: Dispatch<SetStateAction<{ identityId: string; shareClassName: string } | null>>;
}) => {
  const companyId = useCompanyId();
  const { i18n } = useLingui();
  const {
    data: { osrVestedAndAllocated },
  } = useOsrVestedAndAllocatedSuspenseQuery({ variables: { companyId, id: osrId }, fetchPolicy: 'no-cache' });

  const rows = osrVestedAndAllocated.filter(e => Number(e.subscribable) > 0);

  if (rows.length === 0) {
    return (
      <Alert>
        <Trans id="No warrant subscriber has vested enough yet" />
      </Alert>
    );
  }

  return (
    <Table sx={{ tableLayout: 'auto', ':hover': { cursor: 'pointer' } }} hoverRow>
      <thead>
        <tr>
          <th />
          <th>
            <Trans id="Share Class" />
          </th>
          <th align="right">
            <Trans id="Vested options" />
          </th>
          <th align="right">
            <Trans id="Available to subscribe" />
          </th>
        </tr>
      </thead>
      <tbody style={{ overflowY: 'auto' }}>
        {rows.map((row, n) => (
          <tr key={n} onClick={() => setSelected({ identityId: row.identity.id, shareClassName: row.shareClass.name })}>
            <td>
              <Identity identity={row.identity} editable={false} />
            </td>
            <td>{row.shareClass.name}</td>
            <td align="right">
              <NumberFormat locale={i18n.locale} maximumFractionDigits={0}>
                {row.vested}
              </NumberFormat>
            </td>
            <td align="right">
              <NumberFormat locale={i18n.locale} maximumFractionDigits={0}>
                {row.subscribable}
              </NumberFormat>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
